import type { UniverseWithDepartments } from '@/types/treeViewTypes'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { getDepartments } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useDepartments(season: string, universeId: number) {
  const navigate = useNavigate()

  const { data, isError, isFetching, isLoading, isSuccess } = useQuery({
    queryKey: queryKeys.departments(universeId, season),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        return getDepartments<UniverseWithDepartments>(season, universeId)
      }
    },
  })

  const navigateToSingleDepartment = useCallback(() => {
    if (!isSuccess || isFetching || data?.departments?.length !== 1)
      return

    void navigate(
      `/${season}/universe/${data.id}/department/${data.departments[0].id}`,
      { replace: true },
    )
  }, [data, isFetching, isSuccess, navigate, season])

  useEffect(() => {
    navigateToSingleDepartment()
  }, [navigateToSingleDepartment])

  return {
    data,
    isError,
    isFetching,
    isLoading,
    isSuccess,
  }
}
